exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gu-mirror{position:fixed!important;margin:0!important;z-index:9999!important;opacity:.8}.gu-hide{display:none!important}.gu-unselectable{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.gu-transit{opacity:.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Synergy/Projects/SFE/Synergy.UI/node_modules/css-loader?{"sourceMap":false,"import":false}!C:/Synergy/Projects/SFE/Synergy.UI/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Synergy/Projects/SFE/Synergy.UI/node_modules/dragula/dist/dragula.min.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../dragula/dist/dragula.min.css
// module chunks = styles